<ng-container *ngIf="directClick; else withMenu">
  <ws-button [tooltip]="tooltip" (click)="onDirectClick($event)" [callToActionType]="callToActionType"
    [disabled]="disabled">
    <span class="text-c" *ngIf="text">{{text}}</span>
    <mat-icon *ngIf="showActionIcon && icon">
      {{icon}}
    </mat-icon>
  </ws-button>
</ng-container>

<ng-template #withMenu>
  <ws-button [mat-menu-trigger-for]="selectorMenu" [tooltip]="tooltip" (click)="onMenuOpened($event)"
    [callToActionType]="callToActionType" [disabled]="disabled">
    <span class="text-c" *ngIf="text">{{text}}</span>
    <mat-icon *ngIf="showActionIcon && icon" [class.open]="menuOpen" [class.closed]="!menuOpen">
      {{icon}}
    </mat-icon>
  </ws-button>

  <mat-menu #selectorMenu class="selector-menu" (closed)="onMenuClosed()">
    <ng-container *ngIf="options && options.length; else noOptions">
      <button
        *ngFor="let option of options; trackBy: trackByOptionId"
        mat-menu-item
        [disabled]="isOptionDisabled(option)"
        [attr.title]="isOptionDisabled(option) && option.tooltip ? option.tooltip : null"
        [ngClass]="{
          'red-send-action': disabledActions && (option.id === 'send_now' || option.id === 'send_programmed')
        }"
        [ngStyle]="{
          'color': disabledActions && (option.id === 'send_now' || option.id === 'send_programmed') ? 'rgba(244, 67, 54, 0.75) !important' : null
        }" (click)="onClickActionWithPreventClose(option, $event)">
        <mat-icon class="menuIcon" *ngIf="option.icon" [ngClass]="{ 'ws-actions-danger-icon': option.danger }"
          [ngStyle]="{
            'color': disabledActions && (option.id === 'send_now' || option.id === 'send_programmed') ? 'rgba(244, 67, 54, 0.75) !important' : null
          }">{{option.icon}}</mat-icon>
        <span class="menuText" [ngClass]="{ 'ws-actions-danger-text': option.danger }" [ngStyle]="{
            'color': disabledActions && (option.id === 'send_now' || option.id === 'send_programmed') ? 'rgba(244, 67, 54, 0.75) !important' : null
          }">{{ formatter(option) }}</span>
      </button>
    </ng-container>
    <ng-template #noOptions>
      <button mat-menu-item>
        <mat-icon *ngIf="showActionIcon && icon" [class.open]="menuOpen" [class.closed]="!menuOpen">
          {{icon}}
        </mat-icon>
        <span class="text-c" *ngIf="text">{{text}}</span>
      </button>
    </ng-template>
  </mat-menu>
</ng-template>